/** SpinBox registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseSpinBox } from './parser';
const spinBoxRegistration = {
    typeName: 'SpinBox',
    parser: parseSpinBox,
};
nodeRegistry.register(spinBoxRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map